import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';

import { APIServices } from '@nx-ws/bhn-enums/api-services.enum';

import { PageDto } from './../shared/page.dto';
import { PageQueriesModel } from './../shared/page-queries.model';
import { ContactDto } from './../contacts/contact.dto';
import { ContactsResourceInfo } from './../contacts/contacts-resource-info.type';

@Injectable()
export class ClientsContactsRestService {
  private serviceUrl = `api/${APIServices.ACCOUNTS}`;

  constructor(private http: HttpClient) {}

  list(
    queries: PageQueriesModel,
    resourceData: ContactsResourceInfo
  ) {
    const url = this.apiUrl(resourceData);
    const options = {
      params: queries.getParams()
    };

    return this.http.get<PageDto<ContactDto>>(url, options).pipe(
      map(d => {
        const page = new PageDto(d);
        page.content = d.content.map(i => new ContactDto(i));
        return page;
      })
    );
  }

  create(d: ContactDto, resourceData: ContactsResourceInfo) {
    const url = this.apiUrl(resourceData);
    return this.http
      .post<ContactDto>(url, d)
      .pipe(map(data => new ContactDto(data)));
  }

  get(contactId: string, resourceData: ContactsResourceInfo) {
    const url = this.apiOneUrl(contactId, resourceData);

    return this.http.get<ContactDto>(url).pipe(map(d => new ContactDto(d)));
  }

  update(d: ContactDto, contactId: string, resourceData: ContactsResourceInfo) {
    const url = this.apiOneUrl(contactId, resourceData);
    return this.http
      .put<ContactDto>(url, d)
      .pipe(map(data => new ContactDto(data)));
  }

  remove(contactId: string, resourceData: ContactsResourceInfo) {
    const url = this.apiOneUrl(contactId, resourceData);
    return this.http.delete<ContactDto>(url);
  }

  private apiOneUrl(contactId: string, resourceData: ContactsResourceInfo) {
    const url = this.apiUrl(resourceData);
    return url + `/${contactId}`;
  }

  private apiUrl({ clientId }: ContactsResourceInfo) {
    return `${this.serviceUrl}/clients/${clientId}/contacts`;
  }
}
